"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
require("./styles.css");
var DownloadIcon = function () { return (react_1.default.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    react_1.default.createElement("g", { "clip-path": "url(#clip0_6_9647)" },
        react_1.default.createElement("path", { d: "M19 9H15V3H9V9H5L12 16L19 9ZM5 18V20H19V18H5Z", fill: "#323232" })),
    react_1.default.createElement("defs", null,
        react_1.default.createElement("clipPath", { id: "clip0_6_9647" },
            react_1.default.createElement("rect", { width: "24", height: "24", fill: "white" }))))); };
exports.default = DownloadIcon;
